import ComponentModule from "@eisinc/Overrides/Components/LocationContentLink";

export * from "@eisinc/Overrides/Components/LocationContentLink";

export default ComponentModule;
